import WildLife from "../../assets/images/landing/wild-life-safari.jpg";
import Spritual from "../../assets/images/landing/sprituals.jpg";
import Lakshadeep from "../../assets/images/landing/lakshadeep.jpg";
import AsiaCruise from "../../assets/images/landing/cruise.jpg";
import DashboardLogo from "../../assets/images/dashboard.jpg";
import Mauritius from "../../assets/images/landing/mauritius.jpg";
import { FaBriefcase, FaMountain, FaUmbrellaBeach, FaUser } from "react-icons/fa";
import { GiWaterfall } from "react-icons/gi";
import {
  // PiBinocularsBold,
  // PiBookBookmark,
  PiFootprints,
  PiIsland,
  PiPark,
  PiPrinterFill,
} from "react-icons/pi";
import { FiSunrise } from "react-icons/fi";
const activityDetailsList = [
  {
    packageName: "Kerala",
    imageUrl: Lakshadeep,
    startingFrom: "₹ 995",
    activities: 20,
  },
  {
    packageName: "Karnataka",
    imageUrl: WildLife,
    startingFrom: "₹ 1199",
    activities: 20,
  },
  {
    packageName: "Jaipur",
    imageUrl: Spritual,
    startingFrom: "₹ 1225",
    activities: 20,
  },
  {
    packageName: "Goa",
    imageUrl: Mauritius,
    startingFrom: "₹ 1595",
    activities: 20,
  },
  {
    packageName: "Kashmir",
    imageUrl: DashboardLogo,
    startingFrom: "₹ 1099",
    activities: 20,
  },
  {
    packageName: "Shimla",
    imageUrl: AsiaCruise,
    startingFrom: "₹ 995",
    activities: 20,
  },
];
const activityOverview =
  "Embark on a tranquil journey from Cochin to Alleppey and Marari Beach, immersing yourself in the serene beauty of Kerala's backwaters. Day one begins with a picturesque drive to Alleppey, where you board a houseboat to cruise through enchanting backwaters. Marvel at palm-fringed canals, paddy fields, and charming hamlets that define the Venice of the East. The houseboat offers a unique experience with a sun deck, fully equipped kitchen, and stunning sunset views. Continue to Marari Beach, where you check in for a relaxing stay. Day two is yours to unwind on the pristine beach. On the final day, return to Cochin, concluding your rejuvenating journey through the captivating landscapes of Kerala.";
const activitiesList = [
  {
    activityName: "Fun Destinations",
    key: "01",
    descriptions:
      "Have an immersive experience with our awesome activity packages.",
  },
  {
    activityName: "Adventure Destinations",
    key: "02",
    descriptions:
      "From high altitudes to layers of the sea, explore every layer of adventure with us.",
  },
  {
    activityName: "Family Destinations",
    key: "03",
    descriptions:
      "Create joyful moments with your loved ones by diving into astonishing adventures.",
  },
];
const durationList = [
  {
    durationName: "Up to 1 hour",
    key: 1,
    value: "Up to 1 hour",
  },
  {
    durationName: "1 to 4 hours",
    value: "1 to 4 hours",
    key: 2,
  },
  {
    durationName: "4 hours to 1 day",
    key: 3,
    value: "4 hours to 1 day",
  },
  {
    durationName: "1 to 3 days",
    key: 4,
    value: "1 to 3 days",
  },
  {
    durationName: "More than 2 days",
    key: 5,
    value: "More than 2 days",
  },
];
const Specials = [
  {
    ratingName: "Free Cancellation",
    key: 1,
    value: "Free Cancellation",
  },
  {
    ratingName: "Private Tour",
    value: "Private Tour",
    key: 2,
  },
  {
    ratingName: "Special Offer",
    key: 3,
    value: "Special Offer",
  },
  {
    ratingName: "New on PlanMiTrip",
    key: 4,
    value: "New on PlanMiTrip",
  },
  {
    ratingName: "Likely To Sell Out",
    key: 5,
    value: "Likely To Sell Out",
  },
];

const userRatingList = [
  {
    ratingName: "(5 star)",
    key: 1,
    rating: 5,
    value: "(5 star)",
  },
  {
    ratingName: "(4 star & up)",
    value: "(4 star & up)",
    key: 2,
    rating: 4,
  },
  {
    ratingName: "(3 star & up)",
    key: 3,
    rating: 3,
    value: "(3 star & up)",
  },
  {
    ratingName: "(2 star & up)",
    key: 4,
    rating: 2,
    value: "(2 star & up)",
  },
  {
    ratingName: "(1 star & up)",
    key: 5,
    rating: 1,
    value: "(1 star & up)",
  },
];

const sortedByList = [
  {
    key: "travellerRating",
    sortedName: "Traveller Rating",
  },
  {
    key: "lowToHigh",
    sortedName: "Price (Low to High)",
  },
  {
    key: "highToLow",
    sortedName: "Price (High to Low)",
  },
];

const packageFaqList = [
  {
    key: "1",
    label: "Q. What's the price of the Kashmir Trip Package from India?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       Not to worry, you don't need to create the items one by one. myBillBook
    //       allows you to import your items in bulk. <br />
    //       - Incase you're a user of Vyapar, Tally, Marg etc, please upload your
    //       file through our mobile app. In the mobile app, you can find this option
    //       in Items tab, by clicking the top right settings button. Contact our
    //       support team for any help.
    //       <br /> - To import items through Excel click here.
    //     </p>
    //   ),
  },
  {
    key: "2",
    label: "Q. What's the best time to visit Kashmir?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       Item Categories allow for easier management of items by grouping similar
    //       items together. Your item categories will also be displayed in your
    //       Online Store to help your customers find what they need easily.
    //     </p>
    //   ),
  },
  {
    key: "3",
    label: "Q. What are the best places to visit in Kashmir?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       myBillBook provides default item fields which are applicable for every
    //       industry. Incase you require to add custom item fields like Batch, Size,
    //       Color etc, you can do that by going to Item Settings and clicking on +
    //       Add Custom Field.
    //     </p>
    //   ),
  },
  {
    key: "4",
    label: "Q. How to plan a Kashmir trip?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       By default, Stock Value is calculated based on Purchase Price entered
    //       for your item multiplied by the current stock of that item. You can
    //       change it to calculate based on Sales Price instead by going to Item
    //       Settings.
    //     </p>
    //   ),
  },
  {
    key: "5",
    label: "Q. Which airline flies to Kashmir?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       MRP and Wholesale Price(along with minimum wholesale quantity) can be
    //       added to your items by enabling these options from Item Settings.
    //     </p>
    //   ),
  },
  {
    key: "6",
    label: "Q. What's the average flight duration between Delhi to Kashmir?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       On myBillBook you can track the full history of your items stock; right
    //       from opening stock to every sale, purchase and adjustment. Click on an
    //       item and then Stock Details to see it. Alternatively, you can select
    //       "Stock Details Report" in the Report section.
    //     </p>
    //   ),
  },
  {
    key: "7",
    label: "What kind of destinations does Kashmir offer to travellers?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       On myBillBook you can track the full history of your items stock; right
    //       from opening stock to every sale, purchase and adjustment. Click on an
    //       item and then Stock Details to see it. Alternatively, you can select
    //       "Stock Details Report" in the Report section.
    //     </p>
    //   ),
  },
  {
    key: "8",
    label: "How many days are enough to explore Kashmir?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       On myBillBook you can track the full history of your items stock; right
    //       from opening stock to every sale, purchase and adjustment. Click on an
    //       item and then Stock Details to see it. Alternatively, you can select
    //       "Stock Details Report" in the Report section.
    //     </p>
    //   ),
  },
  {
    key: "9",
    label: "Is Kashmir worth travelling to?",
    children: (
      <p className="text-[12px] text-center font-normal">No data found..</p>
    ),
    //   children: (
    //     <p className="text-[12px]">
    //       On myBillBook you can track the full history of your items stock; right
    //       from opening stock to every sale, purchase and adjustment. Click on an
    //       item and then Stock Details to see it. Alternatively, you can select
    //       "Stock Details Report" in the Report section.
    //     </p>
    //   ),
  },
];
const activityCategoriesList = [
  { label: "Nature and Wildlife Tours", count: 110, icon: <FaMountain /> },
  { label: "Multi-day Tours", count: 155, icon: <FaBriefcase /> },
  { label: "Islands", count: 14, icon: <PiIsland /> },
  { label: "Full-day Tours", count: 125, icon: <FiSunrise /> },
  { label: "Safari", count: 22, icon: <FaMountain /> },
  { label: "Theme Park", count: 22, icon: <PiPark /> },
  { label: "BEACH", count: 22, icon: <FaUmbrellaBeach /> },
  { label: "WaterFalls", count: 22, icon: <GiWaterfall /> },
  { label: "Mountains", count: 36, icon: <FaMountain /> },
  { label: "Day Trips", count: 96, icon: <FaBriefcase /> },
  { label: "Private Sightseeing Tours", count: 407, icon: <FaUser /> },
  { label: "Nature & Wildlife Areas", count: 79, icon: <PiPrinterFill /> },
  { label: "Hiking Tours", count: 38, icon: <PiFootprints /> },
];

const areaActivityReview = [
  { label: "Reviews", value: "Reviews" },
  { label: "Q & A", value: "Q & A" },
];

export {
  activityDetailsList,
  activitiesList,
  packageFaqList,
  sortedByList,
  activityCategoriesList,
  Specials,
  durationList,
  userRatingList,
  activityOverview,
  areaActivityReview,
};
